import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AgrochemProductsDashboardComponent} from './agrochem-products-dashboard/agrochem-products-dashboard.component';
import {AgrochemProductsDetailsComponent} from './agrochem-products-details/agrochem-products-details.component';
import {MDBBootstrapModule} from 'angular-bootstrap-md';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared/shared.module';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {FormsModule} from '@angular/forms';



@NgModule({
  declarations: [
    AgrochemProductsDashboardComponent,
    AgrochemProductsDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MDBBootstrapModule,
    RouterModule,
    SharedModule,
    LazyLoadImageModule,
  ],
  exports: [
    AgrochemProductsDashboardComponent,
    AgrochemProductsDetailsComponent
  ]
})
export class AgrochemProductsModule { }
